import React from "react";
import styled from "styled-components";
import Reveal from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

// TODO (Amiri): replace these with your real support details.
export const CONTACT = {
  email: "hello@amoraweddings.com",
  whatsapp: "38344000000", // international format, no +
  instagram: "amoraweddings",
};

export default function ContactSection() {
  const { lang } = useLang();
  const sq = lang === "sq";

  return (
    <Section id="contact">
      <Inner>
        <Reveal>
          <Eyebrow>✦ {sq ? "Kontakt" : "Contact"}</Eyebrow>
          <h2>{sq ? "Na kontakto" : "Get in touch"}</h2>
          <p className="sub">
            {sq
              ? "Ke pyetje për listimin, pagesën ose platformën? Jemi këtu."
              : "Questions about your listing, payment or the platform? We're here."}
          </p>
        </Reveal>

        <Reveal delay={120}>
          <Channels>
            <a className="primary" href={`mailto:${CONTACT.email}`}>
              ✉ {CONTACT.email}
            </a>
            <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer">
              WhatsApp
            </a>
            <a href={`https://instagram.com/${CONTACT.instagram}`} target="_blank" rel="noreferrer">
              Instagram
            </a>
          </Channels>
        </Reveal>

        <Reveal delay={200}>
          <Note>
            {sq
              ? "Përgjigjemi zakonisht brenda 24 orëve. Për çështje pagese ose aktivizimi, shkruaj nga e njëjta email-adresë që përdore gjatë regjistrimit."
              : "We usually reply within 24 hours. For payment or activation issues, write from the same email you used during registration."}
          </Note>
        </Reveal>
      </Inner>
    </Section>
  );
}

const Section = styled.section`
  background: ${({ theme }) => theme.colors.creamDeep};
  border-top: 1px solid ${({ theme }) => theme.colors.hair};
  padding: clamp(64px, 9vw, 110px) clamp(20px, 5vw, 40px);
`;

const Inner = styled.div`
  max-width: 560px;
  margin: 0 auto;
  text-align: center;
`;

const Eyebrow = styled.div`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.rose};
  & + h2 {
    margin: 14px 0 12px;
    font-family: ${({ theme }) => theme.font.display};
    font-weight: 500;
    font-size: clamp(28px, 5vw, 44px);
    color: ${({ theme }) => theme.colors.ink};
  }
  & + h2 + .sub { color: ${({ theme }) => theme.colors.inkSoft}; font-size: 16px; line-height: 1.6; max-width: 440px; margin: 0 auto; }
`;

const Channels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 420px;
  margin: clamp(28px, 4vw, 40px) auto 0;
  a {
    text-align: center;
    text-decoration: none;
    border: 1px solid ${({ theme }) => theme.colors.hair};
    border-radius: 100px;
    padding: 15px 24px;
    font-size: 15px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.ink};
    background: ${({ theme }) => theme.colors.surface};
    transition: 0.2s;
    &:hover { border-color: ${({ theme }) => theme.colors.green}; transform: translateY(-2px); }
    &.primary { background: ${({ theme }) => theme.colors.green}; color: ${({ theme }) => theme.colors.cream}; border-color: ${({ theme }) => theme.colors.green}; }
  }
`;

const Note = styled.p`
  margin: 26px auto 0;
  max-width: 460px;
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: 14px;
  line-height: 1.6;
`;
